window.recaptchaInitV3 = function recaptchaInitV3() {
    const captchaFields = document.querySelectorAll('.g-recaptcha-response-v3')

    captchaFields.forEach(async (f) => {
        console.log({ f })
        const token = await grecaptcha.execute(window.recaptcha_key, {
            action:'validate_captcha_v3'
        })

        console.log({ token })

        f.value = token
    })
}
